__webpack_require__.p = "/create-ai-trans/";